import * as React from 'react';
import ICoverImageComponent, { TCoverImageComponent } from './ICoverImageComponent';
import ImageUploader from '../ImageUploader/ImageUploader';
import SaveHOC from '../HOC/SaveHOC';
import { connect } from 'react-redux';
import { setFormDirty } from '@company/features/action.company';

const isEqual = require('lodash.isequal');
import * as style from './CoverImageComponentStyle.module.scss'

export class CoverImageComponent extends React.Component<ICoverImageComponent, TCoverImageComponent> {

  state: TCoverImageComponent = {
    data: {
      id: Number(this.props.cover_photo.id),
      url: this.props.cover_photo.url,
    },
  };

  UNSAFE_componentWillReceiveProps(nextProps: ICoverImageComponent) {
    if (!isEqual(this.props.cover_photo, nextProps.cover_photo)) {
      this.setState({
        data: nextProps.cover_photo,
      });
    }
  }

  componentDidUpdate(prevProps: ICoverImageComponent, prevState: TCoverImageComponent) {
    if (!isEqual(prevState, this.state) && this.props.editMode && !this.props.formDirty) {
      this.props.dispatch(setFormDirty(true));
    }
  }

  shouldComponentUpdate(nextProps: ICoverImageComponent, nextState: TCoverImageComponent) {
    return this.props.formDirty === nextProps.formDirty;
  }

  getImageId = (data: { id: number; url: string }) => {
    this.setState({
      data,
    });
  }

  render() {
    const backgroundStyle = this.state.data.url !== null ? {
      backgroundImage: `url(${this.state.data.url})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    } : {};
    const imageUploader = this.props.editMode ? (
      <React.Fragment>
        <div className={[style.cropperScroll].join(' ')}>
          <ImageUploader
            getImageId={this.getImageId}
            type="cover"
            avatar={this.state.data.url}
            loaderFullWidth={true}
            uploadSizeLimit={5}
          />
          <p className={[style.editMode, 'test-edit-mode'].join(' ')}>
            <span className="fa fa-camera" /> Update cover image
          </p>
        </div>
      </React.Fragment>
    ) : null;
    return (
      <div className={style.coverContainer} style={backgroundStyle}>
        {imageUploader}
      </div>
    );
  }
}

const mapStateToProps = (store:any) => {
  return {
    formDirty: store.companyReducer.formDirty,
    cover_photo: store.companyReducer.cover_photo,
  };
};

export default connect(mapStateToProps)(SaveHOC(CoverImageComponent, 'cover_photo'));

